/**
 *
 * ListModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import ModalContent from './ModalContent';

function ListModal({ data, lists, onClose, open, onSubmit }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <ModalContent
          data={data[0]}
          lists={lists}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </div>
    </Modal>
  );
}

ListModal.propTypes = {
  data: PropTypes.array,
  lists: PropTypes.array,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default ListModal;
